import React from 'react'

import { ItemProps } from './Item.types'
import styles from '../MenuList.module.scss'

export const Item = ({ children, icon, role, ...props }: ItemProps) => {
  return (
    <li
      className={styles['hds-menu-list__item']}
      role={role || 'menuitem'}
      {...props}
    >
      {icon}
      {children}
    </li>
  )
}
